/* BLED ELEVEN — bandeau cookies maison (markup : snippets/b26-cookies.liquid · styles : assets/b26-cookies.css).
   - Le choix est gardé 6 mois sur l'appareil (clé b26-consent), puis redemandé. Changer data-version dans le snippet
     (et V dans layout/theme.liquid) redemande à tout le monde, par exemple après l'ajout d'une appli.
   - Le choix est transmis à Shopify (Shopify.customerPrivacy.setTrackingConsent) : Shopify autorise ou bloque ensuite
     ses pixels (Google, Meta, TikTok, ParcelPanel, Printful…). Klaviyo est coupé par le cookie __kla_off tant que la
     publicité n'est pas acceptée, et le « vu récemment » du thème n'est pas enregistré sans la personnalisation.
   - Retirer son accord efface les cookies des traceurs concernés puis recharge la page (pour couper ce qui tourne déjà).
   - Tout lien vers #shopifyReshowConsentBanner ou #gerer-cookies, ou portant data-b26ck-open, ouvre les préférences. */
(function () {
  'use strict';
  if (window.B26Cookies) return;
  var root = document.getElementById('b26ck');
  if (!root) return;

  var KEY = 'b26-consent', FLASH = 'b26ck-flash', DAY = 864e5, MAX_AGE = 182 * DAY;
  var VERSION = parseInt(root.getAttribute('data-version'), 10) || 1;
  var CATS = ['a', 'm', 'p'];
  var NB = String.fromCharCode(160);
  var OPENERS = '[data-b26ck-open],a[href$="#shopifyReshowConsentBanner"],a[href$="#gerer-cookies"]';
  var MSG = { accept: 'Tout est accepté.', refuse: 'Tout est refusé.', save: 'Tes choix sont enregistrés.' };

  var html = document.documentElement;
  var bar = root.querySelector('[data-ck-banner]');
  var panel = root.querySelector('[data-ck-panel]');
  var box = panel.querySelector('.b26ck-panel__box');
  var scroller = panel.querySelector('[data-ck-scroll]');
  var toast = root.querySelector('[data-ck-toast]');
  var sws = panel.querySelectorAll('[data-ck-sw]');
  var state = window.__b26ck || (window.__b26ck = { c: null });
  var lastFocus = null, toastTimer = 0, queue = [], apiReady = false, waiting = false;

  /* ---------- Choix enregistré sur l'appareil ---------- */
  function readRaw() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function isValid(c) {
    return !!(c && c.v === VERSION && typeof c.t === 'number' && Date.now() - c.t < MAX_AGE);
  }
  function record(a, m, p) {
    return { v: VERSION, t: Date.now(), a: a ? 1 : 0, m: m ? 1 : 0, p: p ? 1 : 0 };
  }
  function save(c) {
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
    state.c = c;
  }

  /* ---------- Garde-fous (mêmes règles que le petit script du head) ---------- */
  function guards(c) {
    if (c && c.m) document.cookie = '__kla_off=; Max-Age=0; path=/';
    else document.cookie = '__kla_off=true; Max-Age=15724800; path=/; SameSite=Lax';
    if (!(c && c.p)) {
      try { localStorage.removeItem('theme-recent'); } catch (e) {}
      try { sessionStorage.removeItem('recent-products'); } catch (e) {}
    }
  }

  /* ---------- Effacement des traceurs quand on retire son accord ---------- */
  var COOKIES = {
    a: /^(_ga|_ga_.+|_gid|_gat.*|_shopify_y|_shopify_s|_shopify_sa_p|_shopify_sa_t|_y|_s|_orig_referrer|_landing_page|shop_analytics)$/,
    m: /^(_fbp|_fbc|_ttp|_tt_enable_cookie|ttcsid.*|ttclid|_gcl_.+|__kla_id|_shopify_marketing|_pin_unauth|_scid.*|_uet.+)$/,
    p: /^$/
  };
  var STORES = { a: /^_ga/, m: /^(__kla|klaviyo|_tt|tt_|_fb|_gcl)/i, p: /^theme-recent$/ };
  function domains() {
    var parts = location.hostname.split('.'), out = [''];
    for (var i = 0; i < parts.length - 1; i++) {
      var d = parts.slice(i).join('.');
      out.push('; domain=' + d, '; domain=.' + d);
    }
    return out;
  }
  function purge(w) {
    var list = document.cookie ? document.cookie.split(';') : [], ds = domains(), i, j, k, n;
    for (i = 0; i < list.length; i++) {
      n = list[i].split('=')[0].trim();
      for (k = 0; k < CATS.length; k++) {
        if (w[CATS[k]] && COOKIES[CATS[k]].test(n)) {
          for (j = 0; j < ds.length; j++) document.cookie = n + '=; Max-Age=0; path=/' + ds[j];
          break;
        }
      }
    }
    try {
      var keys = Object.keys(localStorage);
      for (i = 0; i < keys.length; i++) {
        for (k = 0; k < CATS.length; k++) {
          if (w[CATS[k]] && STORES[CATS[k]].test(keys[i])) { localStorage.removeItem(keys[i]); break; }
        }
      }
    } catch (e) {}
    if (w.p) { try { sessionStorage.removeItem('recent-products'); } catch (e) {} }
  }

  /* ---------- API de consentement Shopify ---------- */
  function api() {
    var S = window.Shopify;
    return S && S.customerPrivacy && typeof S.customerPrivacy.setTrackingConsent === 'function' ? S.customerPrivacy : null;
  }
  function flush(a) {
    waiting = false;
    apiReady = !!a;
    var q = queue;
    queue = [];
    for (var i = 0; i < q.length; i++) { try { q[i](a || null); } catch (e) {} }
  }
  function withApi(cb) {
    if (apiReady && api()) return cb(api());
    queue.push(cb);
    if (waiting) return;
    waiting = true;
    var t0 = Date.now(), finished = false;
    function finish(a) { if (!finished) { finished = true; flush(a); } }
    setTimeout(function () { finish(api()); }, 10000);
    (function wait() {
      var S = window.Shopify;
      if (S && typeof S.loadFeatures === 'function') {
        try {
          S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { finish(err ? null : api()); });
        } catch (e) { finish(api()); }
        return;
      }
      if (api()) return finish(api());
      if (Date.now() - t0 > 9000) return finish(null);
      setTimeout(wait, 50);
    })();
  }
  function shopState(a) {
    var s = {};
    try { s = a.currentVisitorConsent() || {}; } catch (e) {}
    return { a: s.analytics || '', m: s.marketing || '', p: s.preferences || '' };
  }
  function explicit(s) {
    for (var k = 0; k < CATS.length; k++) if (s[CATS[k]] !== 'yes' && s[CATS[k]] !== 'no') return false;
    return true;
  }
  function allowed(a) {
    var r = { a: false, m: false, p: false };
    try { r.a = !!a.analyticsProcessingAllowed(); } catch (e) {}
    try { r.m = !!a.marketingAllowed(); } catch (e) {}
    try { r.p = !!a.preferencesProcessingAllowed(); } catch (e) {}
    return r;
  }
  function tell(c, cb) {
    withApi(function (a) {
      var called = false;
      function fin(ok) { if (!called) { called = true; if (cb) cb(ok); } }
      if (!a) return fin(false);
      setTimeout(function () { fin(false); }, 4000);
      try {
        a.setTrackingConsent({ analytics: !!c.a, marketing: !!c.m, preferences: !!c.p, sale_of_data: !!c.m }, function (r) { fin(!(r && r.error)); });
      } catch (e) { fin(false); }
    });
  }

  /* ---------- Décision ---------- */
  function decide(c, how) {
    var prev = state.c, before = { a: !!(prev && prev.a), m: !!(prev && prev.m), p: !!(prev && prev.p) };
    var a = apiReady ? api() : null;
    if (a) {
      var now = allowed(a);
      before.a = before.a || now.a;
      before.m = before.m || now.m;
      before.p = before.p || now.p;
    }
    var rec = record(c.a, c.m, c.p);
    var lost = { a: before.a && !rec.a, m: before.m && !rec.m, p: before.p && !rec.p };
    var reload = lost.a || lost.m;
    save(rec);
    guards(rec);
    if (lost.a || lost.m || lost.p) purge(lost);
    hideBanner();
    closePanel();
    showToast(how);
    try { document.dispatchEvent(new CustomEvent('b26:consent', { detail: rec })); } catch (e) {}
    tell(rec, function () {
      if (!reload) return;
      purge(lost);
      try { sessionStorage.setItem(FLASH, how); } catch (e) {}
      location.reload();
    });
  }

  /* ---------- Bandeau ---------- */
  function whenStyled(cb) {
    var t0 = Date.now();
    (function check() {
      var ok = false;
      try { ok = getComputedStyle(root).getPropertyValue('--b26ck-ready').trim() === '1'; } catch (e) {}
      if (ok || Date.now() - t0 > 4000) return cb();
      setTimeout(check, 40);
    })();
  }
  function introDelay() {
    // Page d'accueil : on laisse finir l'animation d'ouverture (2,1 s) avant de montrer le bandeau.
    var intro = document.querySelector('.b26-intro');
    if (!intro || html.classList.contains('b26-nointro')) return 0;
    var t = window.performance && performance.now ? performance.now() : 0;
    return Math.max(0, 2300 - t);
  }
  function showBanner(force) {
    if (!force && isValid(state.c)) return;
    whenStyled(function () {
      setTimeout(function () {
        if (!force && isValid(state.c)) return;
        bar.hidden = false;
        html.classList.add('b26ck-open');
        bar.classList.add('is-in');
        reserveSpace();
      }, introDelay());
    });
  }
  /* B26 conversion: on mobile the bar used to cover the bottom of the page (Duo/Trio pack row, add to cart).
     We reserve its height at the bottom of the page so everything can be scrolled above it, and once the visitor
     scrolls we shrink it to a compact strip (same three equal choices, full text still in « Personnaliser »). */
  var ro = null;
  function reserveSpace() {
    function set() { html.style.setProperty('--b26ck-h', (bar.hidden ? 0 : bar.offsetHeight) + 'px'); }
    set();
    if (!ro && window.ResizeObserver) { ro = new ResizeObserver(set); ro.observe(bar); }
    if (!reserveSpace.s) {
      reserveSpace.s = 1;
      var y0 = window.pageYOffset || 0;
      window.addEventListener('scroll', function onS() {
        if (bar.hidden) return;
        if (Math.abs((window.pageYOffset || 0) - y0) > 60 && window.matchMedia('(max-width:749px)').matches) {
          bar.classList.add('is-mini'); window.removeEventListener('scroll', onS);
        }
      }, { passive: true });
    }
  }
  function hideBanner() {
    html.style.removeProperty('--b26ck-h');
    bar.hidden = true;
    bar.classList.remove('is-in');
    html.classList.remove('b26ck-open');
  }

  /* ---------- Panneau des préférences ---------- */
  function focusEl(el) {
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }
  function syncSwitches() {
    var c = state.c;
    for (var i = 0; i < sws.length; i++) {
      sws[i].setAttribute('aria-checked', c && c[sws[i].getAttribute('data-ck-sw')] ? 'true' : 'false');
    }
  }
  function readSwitches() {
    var c = {};
    for (var i = 0; i < sws.length; i++) c[sws[i].getAttribute('data-ck-sw')] = sws[i].getAttribute('aria-checked') === 'true';
    return c;
  }
  function jump(id) {
    var el = document.getElementById(id);
    if (!el) return;
    scroller.scrollTop = Math.max(0, el.offsetTop - 8);
    focusEl(el);
  }
  function openPanel(target) {
    if (!panel.hidden) { if (target) jump(target); return; }
    syncSwitches();
    lastFocus = document.activeElement;
    whenStyled(function () {
      panel.hidden = false;
      panel.classList.add('is-in');
      html.classList.add('b26ck-lock');
      scroller.scrollTop = 0;
      if (target) jump(target);
      else focusEl(box);
    });
  }
  function closePanel() {
    if (panel.hidden) return;
    panel.hidden = true;
    panel.classList.remove('is-in');
    html.classList.remove('b26ck-lock');
    var f = lastFocus;
    lastFocus = null;
    if (f && f !== document.body && f.focus && html.contains(f) && f.offsetParent !== null) focusEl(f);
  }
  function focusables() {
    var list = box.querySelectorAll('button,a[href],[tabindex="0"]'), out = [];
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) out.push(list[i]);
    return out;
  }

  /* ---------- Message de confirmation ---------- */
  function showToast(how) {
    if (!MSG[how]) return;
    clearTimeout(toastTimer);
    toast.textContent = '';
    var b = document.createElement('b'), s = document.createElement('span');
    b.textContent = MSG[how];
    s.textContent = 'Modifiable à tout moment via «' + NB + 'Gérer mes cookies' + NB + '», en bas de page.';
    toast.appendChild(b);
    toast.appendChild(s);
    toast.classList.remove('is-in');
    void toast.offsetWidth;
    toast.classList.add('is-in');
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-in');
      toastTimer = setTimeout(function () { toast.textContent = ''; }, 400);
    }, 4200);
  }

  /* ---------- Bandeau Shopify (gardé actif mais masqué) ---------- */
  function patchNative() {
    var pb = window.privacyBanner;
    if (!pb || pb.__b26) return;
    try {
      pb.showPreferences = function () { openPanel(); return Promise.resolve(); };
      pb.showBanner = function () { showBanner(true); return Promise.resolve(); };
      pb.__b26 = true;
    } catch (e) {}
  }
  function watchNative() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      var p = document.getElementById('shopify-pc__prefs');
      if (!p || p.__b26 || p.style.display === 'none') return;
      p.__b26 = true;
      setTimeout(function () {
        var x = document.getElementById('shopify-pc__prefs__header-close');
        if (x) x.click();
        p.style.display = 'none';
        document.body.style.removeProperty('overflow');
        openPanel();
      }, 0);
    }).observe(document.body, { childList: true });
  }

  /* ---------- Lien « Gérer mes cookies » dans le menu légal du pied de page ---------- */
  function addMenuLink() {
    var links = document.querySelectorAll('footer a[href*="/pages/politique-de-cookies"]');
    for (var i = 0; i < links.length; i++) {
      var li = links[i].closest ? links[i].closest('li') : null;
      if (!li || !li.parentNode || li.parentNode.querySelector('[data-b26ck-open]')) continue;
      var item = li.cloneNode(false), a = document.createElement('a');
      a.href = '#shopifyReshowConsentBanner';
      a.className = links[i].className;
      a.setAttribute('data-b26ck-open', '');
      a.textContent = 'Gérer mes cookies';
      item.appendChild(a);
      li.parentNode.insertBefore(item, li.nextSibling);
    }
  }

  /* ---------- Synchronisation entre onglets et retour arrière ---------- */
  function resync() {
    var raw = readRaw(), cur = state.c;
    if (!isValid(raw) || (cur && cur.t === raw.t)) return;
    var lost = cur && ((cur.a && !raw.a) || (cur.m && !raw.m));
    state.c = raw;
    hideBanner();
    if (!panel.hidden) syncSwitches();
    if (lost) location.reload();
  }

  /* ---------- Démarrage ---------- */
  function start() {
    var raw = readRaw();
    if (isValid(raw)) {
      state.c = raw;
      guards(raw);
      // Shopify doit refléter le choix enregistré (son cookie a pu être effacé entre-temps).
      withApi(function (a) {
        if (!a) return;
        var s = shopState(a), c = state.c, k, stricter = false, differs = false;
        for (k = 0; k < CATS.length; k++) {
          if (c[CATS[k]] && s[CATS[k]] === 'no') { c[CATS[k]] = 0; stricter = true; }
        }
        if (stricter) { save(c); guards(c); }
        for (k = 0; k < CATS.length; k++) if (s[CATS[k]] !== (c[CATS[k]] ? 'yes' : 'no')) differs = true;
        if (differs) tell(c);
      });
      return;
    }
    state.c = null;
    if (window.Shopify && window.Shopify.designMode) return;
    var expired = !!(raw && typeof raw === 'object'), shown = false;
    var timer = setTimeout(function () { shown = true; showBanner(); }, 1500);
    withApi(function (a) {
      clearTimeout(timer);
      if (a && !expired) {
        // Choix déjà fait avec l'ancien bandeau Shopify : on le reprend tel quel.
        var s = shopState(a);
        if (explicit(s)) {
          var c = record(s.a === 'yes', s.m === 'yes', s.p === 'yes');
          save(c);
          guards(c);
          if (shown) hideBanner();
          return;
        }
      }
      if (a && expired) {
        // Accord de plus de 6 mois : on coupe tout en attendant le nouveau choix.
        var al = allowed(a);
        if (al.a || al.m || al.p) { purge(al); tell({ a: 0, m: 0, p: 0 }); }
      }
      if (!shown) { shown = true; showBanner(); }
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ck-close],[data-ck-sw],[data-ck-more],[data-ck-accept],[data-ck-refuse],[data-ck-save],[data-ck-custom],[data-ck-partners]') : null;
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-ck-accept')) return decide({ a: 1, m: 1, p: 1 }, 'accept');
    if (t.hasAttribute('data-ck-refuse')) return decide({ a: 0, m: 0, p: 0 }, 'refuse');
    if (t.hasAttribute('data-ck-save')) return decide(readSwitches(), 'save');
    if (t.hasAttribute('data-ck-custom')) return openPanel();
    if (t.hasAttribute('data-ck-partners')) return openPanel('b26ck-partners');
    if (t.hasAttribute('data-ck-close')) return closePanel();
    if (t.hasAttribute('data-ck-sw')) {
      t.setAttribute('aria-checked', t.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      return;
    }
    if (t.hasAttribute('data-ck-more')) {
      var open = t.getAttribute('aria-expanded') !== 'true', body = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
    }
  });

  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      closePanel();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (e.shiftKey && (cur === first || cur === box || !box.contains(cur))) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && (cur === last || !box.contains(cur))) { e.preventDefault(); focusEl(first); }
  });

  // Capture : passe avant le gestionnaire du bandeau Shopify, qui ouvrirait sa propre fenêtre (masquée).
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(OPENERS) : null;
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    openPanel();
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) resync(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) resync(); });
  window.addEventListener('load', patchNative);

  var flash = null;
  try { flash = sessionStorage.getItem(FLASH); sessionStorage.removeItem(FLASH); } catch (e) {}
  if (flash) showToast(flash);
  patchNative();
  watchNative();
  addMenuLink();
  start();
  if (/#(gerer-cookies|shopifyReshowConsentBanner)$/.test(location.hash)) openPanel();

  window.B26Cookies = {
    open: function () { openPanel(); },
    state: function () { return state.c; },
    version: VERSION
  };
})();
